import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";

import CustomFormCheck from "utils/CustomFormCheck";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function DatapulseAccess({
  pageLocator,
  setFirstAlert,
  setLastAlert,
  selectedUsers,
  showUsers,
  clientUsers,
  addNewPerson,
  removePerson,
  changePerson,
  submitForm,
  onboarding_progress,
}) {
  pageLocator();
  const route = useContext(RouterContext);
  const nextPage = getNextPage(onboarding_progress);
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (form.checkValidity() === true) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  const dpAccessBox = (user, userEmail, disabled) => {
    return (
      <>
        <div className="dp-access-box mt-4" style={{ backgroundColor: "#e1e1e1", padding: "15px 20px" }}>
          {
            disabled &&
            <div>
              <p style={{ color: "red" }}>This email already has access to DataPulse</p>
            </div>
          }
          <Row className="pb-3 justify-content-center text-left">
            <Col>
              <p className="f16 light-primary visby-bold">Add person</p>
            </Col>
            <Col className="d-flex pr-0 justify-content-end">
              <i onClick={() => removePerson(user.id, userEmail)} className="fas fa-minus-circle"></i>
            </Col>
          </Row>

          <Row className="pb-1 justify-content-center text-left">
            <Col>
              <p className="f14 pl-2 nunito-regular light-primary">First Name (required)</p>
            </Col>
            <Col>
              <p className="f14 pl-2 nunito-regular light-primary">Last Name (required)</p>
            </Col>
          </Row>

          <Row className="pb-1 justify-content-center">
            <Col>
              <Form.Control
                required
                type="text"
                size="sm"
                className="pb-2  mb-2 "
                value={user.first_name ? user.first_name : ""}
                onChange={(e) => changePerson(user.id, userEmail, "first_name", e.target.value)}
                onFocus={(e) => {
                  setFirstAlert(false);
                }}
                id="onboard_first_name"
                disabled={disabled}
              />
            </Col>
            <Col>
              <Form.Control
                required
                type="text"
                size="sm"
                onChange={(e) => changePerson(user.id, userEmail, "last_name", e.target.value)}
                onFocus={(e) => {
                  setLastAlert(false);
                }}
                id="onboard_last_name"
                className="pb-2  mb-2 "
                value={user.last_name ? user.last_name : ""}
                disabled={disabled}
              />
            </Col>
          </Row>

          <Row className="pb-1 justify-content-center text-left">
            <Col>
              <p className="f14 pl-2 light-primary nunito-regular">Email (required)</p>
            </Col>
          </Row>
          <Row className="pb-3 justify-content-center">
            <Col>
              <Form.Control
                size="sm"
                required
                type="email"
                onChange={(e) => changePerson(user.id, userEmail, "email", e.target.value)}
                id="onboard_email"
                className=" mb-2"
                value={userEmail ? userEmail : ""}
                disabled={disabled}
              />
            </Col>
          </Row>

          <Row className="pb-3 justify-content-center text-left">
            <Col md={4}>
              <p className="pb-1 f14 pl-2 light-primary nunito-regular">Phone</p>
              <Form.Control
                size="sm"
                onChange={(e) => changePerson(user.id, userEmail, "phone_number", e.target.value)}
                id="onboard_phone"
                className="mb-2"
                pattern="[1-9]{1}[0-9]{9}"
                placeholder="1231231234"
                value={user.phone_number ? user.phone_number : ""}
                disabled={disabled}
              />
            </Col>

            <Col md={8}>
              <p className="pb-1 f14 pl-2 light-primary nunito-regular">Job Title</p>
              <Form.Control
                size="sm"
                onChange={(e) => changePerson(user.id, userEmail, "job_title", e.target.value)}
                id="onboard_job_title"
                className="mb-2"
                value={user.job_title ? user.job_title : ""}
                disabled={disabled}
              />
            </Col>
          </Row>

          {/* Commenting this out for now since this field doesn't exist anymore and is not displayed anywhere
          <Row>
            <Col>
              <div className="light-label">
                <CustomFormCheck
                  checked={user.is_primary_point_of_contact ? user.is_primary_point_of_contact : false}
                  id="onboarding-poc"
                  onChange={(e) => changePerson(user.id, userEmail, "is_primary_point_of_contact", e.target.value)}
                  label="Primary point of contact"
                  disabled={disabled}
                />
              </div>
            </Col>
          </Row> */}
        </div>
      </>
    );
  };

  return (
    <>
      <Row style={{ backgroundColor: "primary" }} className="pb-3 text-center justify-content-center">
        <Col>
          <p className="pb-3 f28 visby-bold primary ">DataPulse Access</p>
        </Col>
      </Row>
      <Row className="pb-3 justify-content-center text-left">
        <Col md={7}>
          <p className=" f16 nunito-regular primary">
            Here we will add folks from the company that will have direct access to DataPulse. Provide the details to the corresponding fields, and then click
            'Add' to add them to the list. You can add as many people as necessary, but we recommend limiting your primary points of contact to only one or two.{" "}
            <strong>All individuals added here will have a DataPulse invitation sent to the email provided for them.</strong>
          </p>
        </Col>
      </Row>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />

      <Row className="mx-auto pt-3" style={{ maxWidth: "1200px" }}>
        {showUsers !== undefined &&
          showUsers.map((box) => {
            let userEmail = box[0];
            if (selectedUsers.some((el) => el.toLowerCase() == userEmail.toLowerCase())) {
              let user = box[1];
              return (
                <Col key={user.id} md={6}>
                  {dpAccessBox(user, userEmail, Object.keys(clientUsers).includes(userEmail) ? true : false)}
                </Col>
              );
            }
          })}
      </Row>

      <Row className="mt-4 mx-auto" style={{ maxWidth: "1200px" }}>
        <Col className="text-center">
          <Button className="btn-sm px-4" variant="success" onClick={() => addNewPerson()}>
            {selectedUsers.length > 0 ? "+ Add another" : "+ Add user"}
          </Button>
        </Col>
      </Row>

      <Row className="justify-content-center" style={{ marginTop: "86px" }}>
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
